import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-angebotsart',
    templateUrl: './angebotsart.component.html',
    styleUrls: ['./angebotsart.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AngebotsartComponent implements OnInit {
    @Input() name: string;
    @Input() sortiment: string;
    @Input() icon: string;

    constructor() {
    }

    ngOnInit() {
    }

}
